<template>
  <b-card class="mb-0">
    <template>
      <div>
        <div
          v-for="direccionv in userData.direccion"
          :key="direccionv.cp"
          variant="light-primary"
        >
          <p v-if="direccionv.calle!=null">
            Calle : <b>{{ direccionv.calle }}</b>
          </p>
          <p v-if="direccionv.numero!=null">
            Numero : <b>{{ direccionv.numero }}</b>
          </p>
          <p v-if="direccionv.interior!=null">
            Interior : <b>{{ direccionv.interior }}</b>
          </p>
          <p v-if="direccionv.colonia!=null">
            Colonia : <b>{{ direccionv.colonia }}</b>
          </p>
          <p v-if="direccionv.cp!=null">
            Municipio : <b>{{ direccionv.municipio.nombre }}</b>
          </p>
          <p v-if="direccionv.cp!=null">
            Código postal : <b>{{ direccionv.cp }}</b>
          </p>
          <p v-if="direccionv.ref1!=null">
            Referencia 1 : <b>{{ direccionv.ref1 }}</b>
          </p>
          <p v-if="direccionv.ref2!=null">
            Referencia 2 : <b>{{ direccionv.ref2 }}</b>
          </p>
        </div>
      </div>
    </template>
  </b-card>
</template>

<script>
import {
  BCard,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
  },
  props: {
    userData: {
      type: Object,
      required: true,
    },
  },
}
</script>
